export default __webpack_public_path__ + "static/media/course-list-icon.34cb4add.svg";